//=================================================
//    summary: DCP Progress LessonView -- Hook
//
//    remarks: 000 Tim 2021/11/05 Create
//             001 Tim 2023/10/23 調整 有無拼音資料顯示 
//                                增加 ClearMemberVariables, InitPropsVariables, InitMemberVariables, IntegrateDisplayData 資料處理流程
//                                Render 拆小單元
//================================================
import React, { useEffect, useRef } from 'react'
import cssProgressLessonView from './ProgressLessonView.module.scss'

import {
    GlobalLibs
} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjProps = {
    "BookSeqNo": 0,
    "LessonIndex": 0,
    "LessonID": "",
    "ReportDataList": [],
    "PracticeLUIndex": null
}

let mobjDisplayData = null
// #endregion Member Variables


const COMP_NAME = "ProgressLessonView"

function ProgressLessonView(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        ClearMemberVariables()
        InitPropsVariables()
        InitMemberVariables()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mrefCleanUp.current()
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function PaintedMe()
    {
        const FUNC_NAME = "PaintedMe"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理資料
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function CleanUp()
    {
        const FUNC_NAME = "CleanUp"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")
        
        mblnInitialized = false

        ClearMemberVariables()
    } // end of CleanUp
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: Lesson Status 按鈕 處理
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function LearningUnitStatusOnTapHandler(PracticeLUIndex, LessonIndex, Status, AccID)
    {
        console.log(COMP_NAME + ".LearningUnitStatusOnTapHandler: ", PracticeLUIndex, LessonIndex, Status, AccID)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(Status) !== 'undefined') &&
            (Status !== window.gNewAssignmentStatusEnum.NotSubmitted) &&
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let strBookSeqNo = mobjProps.BookSeqNo.toString().PadLeft(2)
            let objCallbackData = {
                "Action": "LessonViewLessonStatusOnTap",
                "LessonIndex": LessonIndex,
                "LessonID": window.gSession.App.BookDef[strBookSeqNo].Lesson[LessonIndex].ID,
                "LUCatSeqNo": parseInt(window.garrPracticeLU[PracticeLUIndex].LUCatSeqNo),
                "Assignee": parseInt(AccID)
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of LearningUnitStatusOnTapHandler
    // #endregion OnTapHandler

    // #region Other Functions
    /*===========================================
    summary: 初始化 區域 參數
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function ClearMemberVariables()
    {
        const FUNC_NAME = "ClearMemberVariables"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        mobjProps = {
            "BookSeqNo": 0,
            "LessonIndex": 0,
            "LessonID": "",
            "ReportDataList": [],
            "PracticeLUIndex": null
        }

        mobjDisplayData = null
    } // end of ClearMemberVariables

    /*===========================================
    summary: 初始化 Props 參數
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function InitPropsVariables()
    {
        const FUNC_NAME = "InitPropsVariables"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        if (
            (typeof(props.Arguments) !== 'undefined') && 
            (props.Arguments !== null)
            )
        {
            if (
                (typeof(props.Arguments.BookSeqNo) !== 'undefined') && 
                (props.Arguments.BookSeqNo !== null) &&
                (parseInt(props.Arguments.BookSeqNo) >= 0)
                )
            {
                mobjProps.BookSeqNo = parseInt(props.Arguments.BookSeqNo)
            } // end of if (parseInt(props.Arguments.BookSeqNo) >= 0)

            if (
                (typeof(props.Arguments.LessonIndex) !== 'undefined') && 
                (props.Arguments.LessonIndex !== null) &&
                (parseInt(props.Arguments.LessonIndex) >= 0)
                )
            {
                mobjProps.LessonIndex = parseInt(props.Arguments.LessonIndex)
            } // end of if (parseInt(props.Arguments.LessonIndex) >= 0)

            if (
                (typeof(props.Arguments.LessonID) !== 'undefined') && 
                (props.Arguments.LessonID !== null) &&
                (props.Arguments.LessonID !== "")
                )
            {
                mobjProps.LessonID = props.Arguments.LessonID
            } // end of if (props.Arguments.LessonID !== "")

            if (
                (typeof(props.Arguments.ReportDataList) !== 'undefined') && 
                (props.Arguments.ReportDataList !== null) &&
                (props.Arguments.ReportDataList.length > 0)
                )
            {
                mobjProps.ReportDataList = props.Arguments.ReportDataList
            } // end of if (props.Arguments.ReportDataList.length > 0)
        } // end of if (props.Arguments !== null)
        
        console.log(COMP_NAME + "." + FUNC_NAME + " END mobjProps: ", mobjProps)
    } // end of InitPropsVariables

    /*===========================================
    summary: 初始化 Member 變數
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function InitMemberVariables()
    {
        const FUNC_NAME = "InitMemberVariables"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        mobjDisplayData = IntegrateDisplayData()

        console.log(COMP_NAME + "." + FUNC_NAME + " END mobjDisplayData: ", mobjDisplayData)
    } // end of InitMemberVariables

    /*===========================================
    summary: 處理顯示資料
    remarks: 000 Tim 2023/10/20 Create
    ===========================================*/
    function IntegrateDisplayData()
    {
        const FUNC_NAME = "IntegrateDisplayData"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")

        let objDisplayData = {
            "IsShowPinyin": false,
            "PITitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinIdentification].Abbreviation,
            "PDTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticePinyinDictation].Abbreviation,
            "PLTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeListening].Abbreviation,
            "PFTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeFluency].Abbreviation,
            "PSTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeSpeaking].Abbreviation,
            "PRTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeReading].Abbreviation,
            "PGTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeGrammarExercises].Abbreviation,
            "PCTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeComposition].Abbreviation,
            "PATitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.PracticeActivity].Abbreviation,
            "RLTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewListening].Abbreviation,
            "RRTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewReading].Abbreviation,
            "RGTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewGrammarExercises].Abbreviation,
            "RCTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewComposition].Abbreviation,
            "RSTitle": window.garrPracticeLU[window.gPracticeLUIndexEnum.ReviewSpeaking].Abbreviation,
            "ReportDataList": []
        }

        if (mobjProps.BookSeqNo <= 2)
        {
            objDisplayData.IsShowPinyin = true
        } // end of if (BookSeqNo <= 2)

        let objReportData = null
        mobjProps.ReportDataList.forEach((ReportData, ReportIndex) => {
            objReportData = {
                "FirstName": ReportData.FirstName,
                "LastName": ReportData.LastName,
                "LoginName": ReportData.LoginName,
                "AccID": ReportData.AccID,

                "PLLessonStatus": ReportData.PracticeListening[mobjProps.LessonIndex],
                "PFLessonStatus": ReportData.PracticeFluency[mobjProps.LessonIndex],
                "PSLessonStatus": ReportData.PracticeSpeaking[mobjProps.LessonIndex],
                "PRLessonStatus": ReportData.PracticeReading[mobjProps.LessonIndex],
                "PGLessonStatus": ReportData.PracticeWritingGE[mobjProps.LessonIndex],
                "PCLessonStatus": ReportData.PracticeWritingC[mobjProps.LessonIndex],
                "PALessonStatus": ReportData.PracticeActivity[mobjProps.LessonIndex],

                "RLLessonStatus": ReportData.ReviewListening[mobjProps.LessonIndex],
                "RRLessonStatus": ReportData.ReviewReading[mobjProps.LessonIndex],
                "RGLessonStatus": ReportData.ReviewWritingGE[mobjProps.LessonIndex],
                "RCLessonStatus": ReportData.ReviewWritingC[mobjProps.LessonIndex],
                "RSLessonStatus": ReportData.ReviewSpeaking[mobjProps.LessonIndex]
            }

            if (objDisplayData.IsShowPinyin)
            {
                objReportData.PILessonStatus = ReportData.PracticePI[mobjProps.LessonIndex]
                objReportData.PDLessonStatus = ReportData.PracticePD[mobjProps.LessonIndex]
            } // end of if (objDisplayData.IsShowPinyin)

            objDisplayData.ReportDataList.push(objReportData)
        }) // end of forEach ReportDataList

        console.log(COMP_NAME + "." + FUNC_NAME + " END objDisplayData: ", objDisplayData)

        return objDisplayData
    } // end of IntegrateDisplayData
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 標題 列 Cls
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function GetTitleRowCls(IsShowPinyin) 
    {
        let objCls = cssProgressLessonView.divTitleRow

        if (!IsShowPinyin)
        {
            objCls = cssProgressLessonView.divTitleRowNoPinyin
        } // end of if (!IsShowPinyin)

        return objCls
    } // end of GetTitleRowCls

    /*===========================================
    summary: 取得 進度表 列 Cls
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function GetProgressRowCls(IsShowPinyin) 
    {
        let objCls = cssProgressLessonView.divProgressRow

        if (!IsShowPinyin)
        {
            objCls = cssProgressLessonView.divProgressRowNoPinyin
        } // end of if (!IsShowPinyin)

        return objCls
    } // end of GetProgressRowCls

    /*===========================================
    summary: 取得 單元 狀態顏色
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function GetSectionBGCls (Status)
    {   
        var objSectionBGCls = cssProgressLessonView.divSectionNotSubmitted

        switch (Status)
        {
            case window.gNewAssignmentStatusEnum.NotSubmitted:
                objSectionBGCls = cssProgressLessonView.divSectionNotSubmitted
                break
            case window.gNewAssignmentStatusEnum.GradePending:
                objSectionBGCls = cssProgressLessonView.divSectionGradePending
                break
            case window.gNewAssignmentStatusEnum.NeedHelp:
                objSectionBGCls = cssProgressLessonView.divSectionNeedHelp
                break
            case window.gNewAssignmentStatusEnum.Completed:
                objSectionBGCls = cssProgressLessonView.divSectionCompleted
                break
            default:
                break
        }
        
        return objSectionBGCls
    } // end of GetSectionBGCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Review Speaking Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewSpeakingCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.ReviewSpeaking, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.RSTitle}
            </div>
        )
    } // end of ComponentReviewSpeakingCell

    /*===========================================
    summary: Review Composition Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewWritingCCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.ReviewComposition, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.RCTitle}
            </div>
        )
    } // end of ComponentReviewWritingCCell

    /*===========================================
    summary: Review Grammar Exercises Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewWritingGECell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.ReviewGrammarExercises, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.RGTitle}
            </div>
        )
    } // end of ComponentReviewWritingGECell

    /*===========================================
    summary: Review Reading Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewReadingCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.ReviewReading, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.RRTitle}
            </div>
        )
    } // end of ComponentReviewReadingCell

    /*===========================================
    summary: Review Listening Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewListeningCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.ReviewListening, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.RLTitle}
            </div>
        )
    } // end of ComponentReviewListeningCell

    /*===========================================
    summary: Practice Activity Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeActivityCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeActivity, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PATitle}
            </div>
        )
    } // end of ComponentPracticeActivityCell
    
    /*===========================================
    summary: Practice Composition Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeWritingCCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeComposition, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PCTitle}
            </div>
        )
    } // end of ComponentPracticeWritingCCell
    
    /*===========================================
    summary: Practice Grammar Exercises Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeWritingGECell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeGrammarExercises, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PGTitle}
            </div>
        )
    } // end of ComponentPracticeWritingGECell
    
    /*===========================================
    summary: Practice Reading Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeReadingCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeReading, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PRTitle}
            </div>
        )
    } // end of ComponentPracticeReadingCell
    
    /*===========================================
    summary: Practice Speaking Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeSpeakingCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeSpeaking, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PSTitle}
            </div>
        )
    } // end of ComponentPracticeSpeakingCell

    /*===========================================
    summary: Practice Fluency Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeFluencyCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeFluency, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PFTitle}
            </div>
        )
    } // end of ComponentPracticeFluencyCell

    /*===========================================
    summary: Practice Listening Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeListeningCell( {PropsLessonIndex, AccID, LessonStatus} )
    {   
        return(
            <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticeListening, PropsLessonIndex, LessonStatus, AccID)}>
                {mobjDisplayData.PLTitle}
            </div>
        )
    } // end of ComponentPracticeListeningCell

    /*===========================================
    summary: Pinyin Dictation Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPinyinDictationCell( {IsShowPinyin, PropsLessonIndex, AccID, LessonStatus} )
    {   
        // DCP Volume 1,2 有PinyinDictation, Volume 3,4 沒有PinyinDictation
        if (IsShowPinyin)
        {
            return(
                <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticePinyinDictation, PropsLessonIndex, LessonStatus, AccID)} >
                    {mobjDisplayData.PDTitle}
                </div>
            )
        } // end of if (IsShowPinyin)
        else
        {
            return ""
        } // end of else
    } // end of ComponentPinyinDictationCell

    /*===========================================
    summary: Pinyin Identfication Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPinyinIdentficationCell( {IsShowPinyin, PropsLessonIndex, AccID, LessonStatus} )
    {   
        // DCP Volume 1,2 有PinyinIdentfication, Volume 3,4 沒有PinyinIdentfication
        if (IsShowPinyin)
        {
            return(
                <div className={GetSectionBGCls(LessonStatus)} onClick={() => LearningUnitStatusOnTapHandler(window.gPracticeLUIndexEnum.PracticePinyinIdentification, PropsLessonIndex, LessonStatus, AccID)} >
                    {mobjDisplayData.PITitle}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentPinyinIdentficationCell

    /*===========================================
    summary: Progress Name Cell 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentProgressNameCell( {FirstName, LastName, LoginName} )
    {   
        return(
            <div className={cssProgressLessonView.divProgressNameCell}>
                {window.Globals.GetUserDisplayName(FirstName, LastName, LoginName)}
            </div>
        )
    } // end of ComponentProgressNameCell
    
    /*===========================================
    summary: Review Title 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentReviewTitle()
    {   
        return(
            <div className={cssProgressLessonView.divReviewTitle}>
                {window.gAppUI.LBL_Review}
            </div>
        )
    } // end of ComponentReviewTitle
                
    /*===========================================
    summary: Practice Title 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentPracticeTitle()
    {   
        return(
            <div className={cssProgressLessonView.divPracticeTitle}>
                {window.gAppUI.LBL_Practice}
            </div>
        )
    } // end of ComponentPracticeTitle

    /*===========================================
    summary: Name Title 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentNameTitle()
    {   
        return(
            <div className={cssProgressLessonView.divNameTitle}>
                {window.gAppUI.LBL_Name}
            </div>
        )
    } // end of ComponentNameTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 進度表 Report Review 欄
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function RenderReviewCellWrapper(ReportData)
    {
        return(
            <>
                <ComponentReviewListeningCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.RLLessonStatus}/>

                <ComponentReviewReadingCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.RRLessonStatus}/>
                
                <ComponentReviewWritingGECell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.RGLessonStatus}/>

                <ComponentReviewWritingCCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.RCLessonStatus}/>

                <ComponentReviewSpeakingCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.RSLessonStatus}/>
            </>
        )
    } // end of RenderReviewCellWrapper

    /*===========================================
    summary: Render 進度表 Report Practice 欄
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function RenderPracticeCellWrapper(ReportData)
    {
        return(
            <>  
                <ComponentPracticeListeningCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PLLessonStatus}/>

                <ComponentPracticeFluencyCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PFLessonStatus}/>

                <ComponentPracticeSpeakingCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PSLessonStatus}/>

                <ComponentPracticeReadingCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PRLessonStatus}/>

                <ComponentPracticeWritingGECell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PGLessonStatus}/>

                <ComponentPracticeWritingCCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PCLessonStatus}/>

                <ComponentPracticeActivityCell PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PALessonStatus}/>
            </>
        )
    } // end of RenderPracticeCellWrapper

    /*===========================================
    summary: Render 進度表 Report Practice Pinyin 欄
    remarks: 000 Tim 2023/10/23 Create
    ===========================================*/
    function RenderPracticePinyinCellWrapper(ReportData, IsShowPinyin)
    {
        return(
            <>
                <ComponentPinyinIdentficationCell IsShowPinyin={IsShowPinyin} 
                    PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PILessonStatus}/>

                <ComponentPinyinDictationCell IsShowPinyin={IsShowPinyin} 
                    PropsLessonIndex={mobjProps.LessonIndex} 
                    AccID={ReportData.AccID} 
                    LessonStatus={ReportData.PDLessonStatus}/>
            </>
        )
    } // end of RenderPracticePinyinCellWrapper

    /*===========================================
    summary: Render 進度表 Report 列
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderReportRowWrapper()
    {
        let blnIsShowPinyin = mobjDisplayData.IsShowPinyin

        return(
            <div className={cssProgressLessonView.divProgressMain}>
                {mobjDisplayData.ReportDataList.map((ReportData, ReportIndex) => 
                    <div key={ReportIndex} className={GetProgressRowCls(blnIsShowPinyin)}>
                        <ComponentProgressNameCell FirstName={ReportData.FirstName} LastName={ReportData.LastName} LoginName={ReportData.LoginName} />

                        {RenderPracticePinyinCellWrapper(ReportData, blnIsShowPinyin)}
                        {RenderPracticeCellWrapper(ReportData)}
                        {RenderReviewCellWrapper(ReportData)}
                    </div>
                )}
            </div>
        )
    } // end of RenderReportRowWrapper

    /*===========================================
    summary: Render 進度表 標題 列
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderTitleRowWrapper()
    {
        return(
            <div className={GetTitleRowCls(mobjDisplayData.IsShowPinyin)}>
                <ComponentNameTitle />
                <ComponentPracticeTitle />
                <ComponentReviewTitle />
            </div>
        )
    } // end of RenderTitleRowWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssProgressLessonView.divMain}>
                {RenderTitleRowWrapper()}
                {RenderReportRowWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return RenderMainWrapper()
    // #endregion Render
}
export default ProgressLessonView